import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, DatePicker, Space, message } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { setItem, getItem } from './utils/utils';

export default function Setting() {
  const isNeedSetBirthDate = !getItem();
  const defaultDate = moment().format('YYYY-MM-DD');
  const storeDate = getItem() || defaultDate;
  const [date, setDate] = useState(storeDate);

  function onChange(date, dateString) {
    setDate(dateString);
  }

  function onSave() {
    try {
      setItem(date);
      message.success('生日日期设置成功!');
    } catch (error) {
      message.error('生日日期设置失败!');
    }
  }

  return (
    <div className="block-center">
      <h1>设置</h1>
      <Link to="/" className="big">返回主页</Link>

      {isNeedSetBirthDate && (
        <div>
          <p>小可爱还没有设置出生日期，请先设置后回主页查看!</p>
        </div>
      )}

      {!isNeedSetBirthDate && <p>修改出生日期</p>}

      <Space>
        <DatePicker
          locale={locale}
          onChange={onChange}
          defaultValue={moment(date, 'YYYY-MM-DD')}
        />
        <Button type="primary" onClick={onSave}>
          确定
        </Button>
      </Space>
    </div>
  );
}
